import React from 'react'
import { string } from 'prop-types'
import {
  Tooltip,
  GlobalIcons,
  IconInfoInformationCircle,
  Typography,
} from '@creditas-ui/react'
import { compose, withDefaultProps, withForwardRef } from '@creditas/utils'
import { CardContainer, LinkStyle } from './components/Card.styles'

const propTypes = {
  title: string.isRequired,
  subtitle: string,
}

const defaultProps = {
  component: 'div',
}

const enhancer = compose(
  withForwardRef,
  withDefaultProps(propTypes, defaultProps),
)

const element = enhancer(function Card(props) {
  const { title, subtitle, testId, ref, component, className, ...other } = props

  return (
    <CardContainer
      data-testid={testId}
      ref={ref}
      as={component}
      className={className}
      {...other}
    >
      <LinkStyle role="link" data-testid={`link-${testId}`}>
        <Tooltip
          content="Envio de propostas 
          desabilitado"
          variant="light"
          local="bottom"
        >
          <Typography color="neutral.60" variant="bodyXlRegular">
            {title}
          </Typography>
          <GlobalIcons
            Icon={IconInfoInformationCircle}
            color="#1F2D27"
            size="medium"
            data-testid="icon-info"
          />
        </Tooltip>
        {subtitle && (
          <Typography color="neutral.40" variant="bodyMdRegular">
            {subtitle}
          </Typography>
        )}
      </LinkStyle>
    </CardContainer>
  )
})

export { element as CardDisabled }
